import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class SpecialtyService {
    public isModalShowing: boolean;

    public showSpecialtyModal = new Subject<boolean>();

    constructor(private activatedRoute: ActivatedRoute, private router: Router) {
        this.showSpecialtyModal.subscribe((value) => {
            this.isModalShowing = value;
        });
    }

    public openHcpModal() {
        this.showSpecialtyModal.next(true);
    }

    public closeHcpModal() {
        this.showSpecialtyModal.next(false);
    }

    public getHcpModalStatus(): Observable<boolean> {
        return this.showSpecialtyModal.asObservable();
    }

    public isStartScreening(): boolean {
        this.activatedRoute.fragment.subscribe((value) => {
            if (value === "start-screening") {
                return true;
            } else {
                return false;
            }
        });
        return false;
    }
}
